import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { X } from "@phosphor-icons/react";

const STORAGE_KEY = "btk_cookies_v1";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      try {
        if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
      } catch {
        setVisible(true);
      }
    }, 900);
    return () => clearTimeout(timer);
  }, []);

  const decide = (value) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ decision: value, at: new Date().toISOString() }));
    } catch {}
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          role="dialog"
          aria-label="Cookie preferences"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-5 left-5 right-5 sm:left-auto sm:right-6 sm:bottom-6 z-50 max-w-md border border-black/10 bg-white shadow-[0_28px_60px_rgba(10,19,38,0.18)]"
        >
          <div className="p-7">
            <div className="flex items-start justify-between gap-4">
              <p className="eyebrow text-brand">
                <span className="rule-line" />
                Cookies
              </p>
              <button
                data-testid="cookie-close-btn"
                onClick={() => decide("declined")}
                aria-label="Close"
                className="text-neutral-400 transition-colors duration-200 hover:text-brand-ink"
              >
                <X size={16} weight="bold" />
              </button>
            </div>
            <h2 className="editorial-h mt-5 text-xl text-brand-ink">We use a few cookies.</h2>
            <p className="mt-3 text-[13px] leading-relaxed text-neutral-600">
              Essential cookies keep this site working. Optional ones (used by our Google reviews
              widget and smooth-scroll) help us improve the experience. See our{" "}
              <Link to="/privacy-policy" className="text-brand underline underline-offset-2 hover:text-brand-dark">
                privacy policy
              </Link>{" "}
              and{" "}
              <Link to="/cookie-policy" className="text-brand underline underline-offset-2 hover:text-brand-dark">
                cookie policy
              </Link>{" "}
              for details.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <button
                data-testid="cookie-accept-btn"
                onClick={() => decide("accepted")}
                className="inline-flex items-center bg-brand px-6 py-3 text-[0.72rem] font-semibold uppercase tracking-[0.22em] text-white transition-[background-color,transform] duration-200 hover:bg-brand-dark hover:-translate-y-0.5"
              >
                Accept all
              </button>
              <button
                data-testid="cookie-decline-btn"
                onClick={() => decide("declined")}
                className="inline-flex items-center border border-brand-ink/20 px-6 py-3 text-[0.72rem] font-semibold uppercase tracking-[0.22em] text-brand-ink transition-[border-color,color] duration-200 hover:border-brand hover:text-brand"
              >
                Essential only
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
